import React, { useEffect } from 'react';
import RACHero from '../components/rac/RACHero';
import RACKeyHighlight from '../components/rac/RACKeyHighlight';
import RACPhilosophy from '../components/rac/RACPhilosophy';
import RACOwnership from '../components/rac/RACOwnership';
import RACHowItWorks from '../components/rac/RACHowItWorks';
import RACLeaseRent from '../components/rac/RACLeaseRent';
import RACWhatYouGet from '../components/rac/RACWhatYouGet';
import RACEarningsTable from '../components/rac/RACEarningsTable';
import RACBenefits from '../components/rac/RACBenefits';
import RACWelfare from '../components/rac/RACWelfare';
import RACExitPolicy from '../components/rac/RACExitPolicy';
import RACTimeline from '../components/rac/RACTimeline';
import RACFAQ from '../components/rac/RACFAQ';
import RACContact from '../components/rac/RACContact';
import RACLegal from '../components/rac/RACLegal';
import './RACProgram.css';

const RACProgram = () => {
  console.log('[RACProgram] Main page component rendered');
  
  // SEO Meta Tags
  useEffect(() => {
    document.title = 'Rent-A-Cow Program | Dairy Asset Hire-Back in India | PharmWealth';
    
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'Own an identified dairy animal and hire it back to PharmWealth for managed operations. Receive monthly hire rent prorated by Active Lease Days. Indicative annualized hire rent rate up to 18% p.a. Ethical, transparent dairy asset ownership by PharmWealth.');
    
    return () => {
      document.title = 'PharmWealth Ventures | Ethical Luxury Dairy & Innovation';
    };
  }, []);
  
  const scrollToContact = () => {
    document.getElementById('rac-contact-section')?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };
  
  const handleTalkToTeam = () => {
    scrollToContact();
  };
  
  const handleRequestCallback = () => {
    scrollToContact();
  };
  
  const handleScheduleMeeting = () => {
    scrollToContact();
  };
  
  return (
    <div className="rac-program-page">
      <RACHero 
        onTalkToTeam={handleTalkToTeam}
        onRequestCallback={handleRequestCallback}
      />
      <RACKeyHighlight />
      <RACPhilosophy />
      <RACOwnership />
      <RACHowItWorks />
      <RACLeaseRent />
      <RACWhatYouGet />
      <RACEarningsTable />
      <RACBenefits />
      <RACWelfare />
      <RACExitPolicy />
      <RACTimeline />
      <RACFAQ />
      <div id="rac-contact-section">
        <RACContact 
          onRequestCallback={handleRequestCallback}
          onScheduleMeeting={handleScheduleMeeting}
        />
      </div>
      <RACLegal />
    </div>
  );
};

export default RACProgram;


